export const newsList = [
  {
    id: "n-1",
    title: "《星际拾荒者》全球票房破 10 亿，科幻电影迎来新浪潮",
    publishDate: "2026-10-12",
    source: "夜无疆影视快报",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20photo%20of%20a%20futuristic%20cinema%20hall%20with%20glowing%20screens%20and%20empty%20seats%2C%20dark%20charcoal%20tones%2C%20warm%20orange%20accent%20lighting%2C%20modern%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-box-01&orientation=landscape",
    summary:
      "上映三周后，《星际拾荒者》全球票房正式突破 10 亿美元，成为本年度最受关注的现象级科幻作品。",
    content: [
      "据发行方公布的数据，《星际拾荒者》上映三周后全球票房正式突破 10 亿美元，其中海外市场贡献超过六成。影片以冷峻的宇宙美学和紧凑的叙事节奏，收获了观众与影评人的双重好评。",
      "影评人普遍认为，影片成功的关键在于它没有停留在视觉奇观上，而是把焦点放在普通人在宏大秩序前的选择。这种「小人物、大世界」的处理方式，正在成为新一代科幻电影的创作趋势。",
      "随着票房持续走高，制片方也透露了后续计划，表示将继续开发同一世界观下的新故事。可以预见，科幻题材将在未来一段时间内保持强劲的市场热度。",
    ],
  },
  {
    id: "n-2",
    title: "2026 年秋季档前瞻：这十部电影值得期待",
    publishDate: "2026-10-09",
    source: "夜无疆观影指南",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20photo%20of%20a%20summer%20blockbuster%20film%20clapperboard%20on%20a%20director%20chair%2C%20dark%20charcoal%20background%2C%20warm%20orange%20lighting%2C%20cinematic%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-summer-02&orientation=landscape",
    summary:
      "从科幻巨制到文艺小品，本季片单类型丰富，我们为你挑选了最值得走进影院的十部作品。",
    content: [
      "秋季档历来是佳作集中亮相的时段。今年这一季的片单覆盖科幻、悬疑、动画与剧情等多个类型，风格跨度明显，几乎可以满足不同观众的口味。",
      "其中既有备受期待的系列续作，也有来自新锐导演的原创作品。多位业内人士表示，原创题材在今年受到的关注度明显上升，观众对新故事的接受度越来越高。",
      "我们根据预告片质量、主创阵容与前期口碑，整理出这份推荐清单，希望能在你选片时提供一些参考。",
    ],
  },
  {
    id: "n-3",
    title: "夜无疆独家：《长夜将明》主创专访，揭秘悬疑剧幕后",
    publishDate: "2026-10-06",
    source: "夜无疆独家",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20photo%20of%20an%20intimate%20interview%20studio%20with%20two%20chairs%20and%20soft%20spotlights%2C%20dark%20charcoal%20tones%2C%20warm%20orange%20accent%20lighting%2C%20professional%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-interview-03&orientation=landscape",
    summary:
      "我们与《长夜将明》的导演和主演聊了聊，关于这部高分悬疑剧背后的创作方法与细节打磨。",
    content: [
      "作为近期讨论度最高的悬疑剧之一，《长夜将明》凭借扎实的剧本和克制的表演赢得了口碑。导演在采访中表示，整部剧的核心并不是「谁是凶手」，而是「人们为什么选择沉默」。",
      "主演也分享了塑造角色的过程。为了呈现角色长期压抑的状态，他在拍摄期间刻意减少了社交，并反复研读真实案件资料，力求每一个眼神都有依据。",
      "剧组透露，许多关键线索都藏在看似不经意的镜头里，观众如果二刷，往往会有全新的发现。这也是该剧被反复讨论的原因之一。",
    ],
  },
  {
    id: "n-4",
    title: "国际电影节获奖名单公布，多部华语片入围",
    publishDate: "2026-10-02",
    source: "夜无疆影视资讯",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20photo%20of%20a%20film%20festival%20awards%20stage%20with%20golden%20trophies%20under%20spotlights%2C%20dark%20charcoal%20background%2C%20warm%20orange%20and%20gold%20lighting%2C%20celebratory%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-festival-04&orientation=landscape",
    summary:
      "本届国际电影节落下帷幕，多部华语作品入围主竞赛单元，并在摄影与技术奖项上有所斩获。",
    content: [
      "本届国际电影节共收到来自全球的上千部报名作品，最终入围主竞赛单元的名单中，华语作品占据了多个重要席位，数量较往年有明显增长。",
      "在技术类奖项方面，多部华语影片凭借出色的摄影与美术获得提名。评审团认为，这批作品在影像语言上的探索令人印象深刻。",
      "业内人士指出，华语电影在国际舞台上的能见度持续提升，与国际团队的合作也日益频繁，这为行业带来了新的创作活力。",
    ],
  },
  {
    id: "n-5",
    title: "流媒体竞争升级，影视平台内容策略迎来新变化",
    publishDate: "2026-09-28",
    source: "夜无疆产业观察",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20photo%20of%20multiple%20floating%20streaming%20screens%20above%20a%20desk%20with%20headphones%2C%20dark%20charcoal%20background%2C%20warm%20orange%20accent%20lighting%2C%20modern%20tech%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-streaming-05&orientation=landscape",
    summary:
      "随着各大平台加码原创内容，影视行业的制作与分发模式正在发生深刻变化。",
    content: [
      "过去一年，流媒体平台在原创内容上的投入持续增长，从剧集到电影，平台自制作品的质量与数量都在提升。这一趋势也改变了传统的制作与发行节奏。",
      "与此同时，观众的选择更加分散，平台之间的竞争从「内容数量」转向「内容辨识度」。能否持续产出有独特风格的作品，成为衡量平台竞争力的关键。",
      "多位从业者认为，未来的内容生态将更加多元，中小成本但风格鲜明的作品有望获得更多机会。",
    ],
  },
  {
    id: "n-6",
    title: "经典 IP 翻拍热潮：是情怀还是创新？",
    publishDate: "2026-09-22",
    source: "夜无疆影视评论",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20photo%20of%20vintage%20film%20reels%20and%20a%20modern%20camera%20side%20by%20side%20on%20a%20dark%20table%2C%20warm%20orange%20accent%20lighting%2C%20nostalgic%20yet%20modern%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-remake-06&orientation=landscape",
    summary:
      "越来越多的经典作品被重新搬上银幕，翻拍究竟是在消费情怀，还是在寻找新的表达？",
    content: [
      "近两年，经典 IP 的翻拍与重启项目明显增多。对于制作方而言，自带观众基础的作品能在起步阶段获得更多关注，但同时也意味着更高的期待与更严苛的比较。",
      "观众的态度则相对复杂。一部分人愿意为熟悉的故事买单，另一部分人则担心翻拍会稀释原作的价值。评论普遍认为，翻拍的关键在于是否提供了新的视角。",
      "真正成功的翻拍，往往不是对原作的简单复刻，而是用当下的语言重新讲述一个仍然动人的内核。这一点，或许比还原度更值得创作者思考。",
    ],
  },
  {
    id: "n-7",
    title: "影视特效技术革新，虚拟拍摄走进大众视野",
    publishDate: "2026-09-15",
    source: "夜无疆技术前线",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20photo%20of%20a%20virtual%20production%20film%20set%20with%20LED%20walls%20and%20cameras%2C%20dark%20charcoal%20tones%2C%20warm%20orange%20accent%20lighting%2C%20futuristic%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-vfx-07&orientation=landscape",
    summary:
      "虚拟拍摄技术正在改变影视制作流程，让许多过去难以实现的场景变得更加可控。",
    content: [
      "所谓虚拟拍摄，是指利用环绕式 LED 屏实时呈现背景，让演员在近乎真实的环境中表演。相比传统绿幕，这种方式可以大幅提升现场的真实感与演员的投入度。",
      "近年来，相关技术的成本逐步下降，越来越多的中小制作团队也开始尝试。技术的普及，让创作者能够把更多精力放在故事本身，而不是被预算和场地所限制。",
      "不过从业者也提醒，技术始终是辅助。真正打动观众的，仍然是扎实的剧本与真诚的表演。",
    ],
  },
  {
    id: "n-8",
    title: "年度剧集盘点：2026 年最受欢迎的十部电视剧",
    publishDate: "2026-09-08",
    source: "夜无疆年度盘点",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20news%20photo%20of%20a%20glowing%20collage%20of%20many%20movie%20posters%20on%20a%20dark%20wall%2C%20warm%20orange%20accent%20lighting%2C%20celebratory%20annual%20recap%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=news-annual-08&orientation=landscape",
    summary:
      "从悬疑到古装，从现实题材到科幻想象，回顾这一年最受观众欢迎的十部剧集。",
    content: [
      "这一年，剧集市场呈现出类型多元、制作精良的特点。悬疑与都市题材依然热门，而古装与科幻作品也在口碑上实现了突破。",
      "从话题度来看，几部以人物群像见长的作品表现尤为突出。观众不再只关注单一主角，而是更愿意为真实而立体的群像买单。",
      "在这份年度盘点中，我们综合了播放热度与口碑评分，挑选出十部最具代表性的剧集，供你补看与回顾。",
    ],
  },
];